export default __webpack_public_path__ + "static/media/computers.ea0515fc.png";